<script setup>
import { ref } from 'vue'

import TabGroup from '@/components/Atoms/TabGroup.vue'
import TabItem from '@/components/Atoms/TabItem.vue'
import PlayoutFilesUploadedTab from './PlayoutFilesUploadedTab.vue'
import PlayoutFilesLiveSourcesTab from './PlayoutFilesLiveSourcesTab.vue'

defineProps({
	playoutId: {
		type: String,
		default: null,
	},
	uploadDirs: {
		type: Array,
		default: () => [],
	},
	loadingUploadDirs: {
		type: Boolean,
		default: false,
	},
})

const emit = defineEmits([
	'open-upload-modal',
	'create-folder',
	'add-file',
	'add-stream',
])

const activeSubTab = ref('uploaded')

const switchTab = (tab) => {
	activeSubTab.value = tab
}
</script>

<template>
	<section class="flex flex-col gap-4 min-w-0 max-w-full">
		<TabGroup class="w-full sm:w-auto">
			<TabItem
				centered
				:isActive="activeSubTab === 'uploaded'"
				:onClick="() => switchTab('uploaded')"
				class="basis-1/2 sm:basis-auto"
			>
				Uploaded files
			</TabItem>
			<TabItem
				centered
				:isActive="activeSubTab === 'live'"
				:onClick="() => switchTab('live')"
				class="basis-1/2 sm:basis-auto"
			>
				Live Sources
			</TabItem>
		</TabGroup>

		<PlayoutFilesUploadedTab
			v-if="activeSubTab === 'uploaded'"
			:playout-id="playoutId"
			:upload-dirs="uploadDirs"
			:loading-upload-dirs="loadingUploadDirs"
			@open-upload-modal="emit('open-upload-modal')"
			@create-folder="(name) => emit('create-folder', name)"
			@add-file="(file) => emit('add-file', file)"
		/>
		<PlayoutFilesLiveSourcesTab
			v-else
			@add-stream="(stream) => emit('add-stream', stream)"
		/>
	</section>
</template>

<style scoped></style>
